import type { AssignmentEntity } from '@data-delivery/permission-ui-api';
import { useQuery } from '@tanstack/react-query';
import { assignmentsQueries } from './assignments-keys';

interface WrappedAssignmentsResponse {
  assignments: AssignmentEntity[];
}

function isWrapped(value: unknown): value is WrappedAssignmentsResponse {
  return (
    typeof value === 'object' &&
    value !== null &&
    'assignments' in value &&
    Array.isArray(value.assignments)
  );
}

export function useBusinessGroupAssignments(businessGroupId: string | undefined) {
  const queryKey = businessGroupId
    ? assignmentsQueries.byBusinessGroup(businessGroupId)
    : assignmentsQueries.byBusinessGroup('');
  const query = useQuery({
    ...queryKey,
    enabled: Boolean(businessGroupId),
    select: (data: unknown) => (isWrapped(data) ? data.assignments : (data as AssignmentEntity[])),
  });
  return {
    assignments: businessGroupId ? query.data ?? [] : [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
